(() => {
  const initialize = () => {
    const root = document.querySelector('.ca-scanners');
    if (!root || root.dataset.scSearchReady) return;
    root.dataset.scSearchReady = 'true';
    const form = root.querySelector('[data-sc-search]');
    const input = form.querySelector('input');
    const status = form.querySelector('[data-sc-status]');
    const list = form.querySelector('ol');
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/\s+/g, ' ');
    const records = [...root.querySelectorAll('[data-sc-record]')].map(el => ({
      el,
      title: el.querySelector('h4, h3, h2')?.textContent.trim() || el.id,
      section: el.closest('.ca-chapter')?.querySelector('.ca-chapter-title')?.textContent.trim() || '',
      body: el.textContent.replace(/\s+/g, ' ').trim(),
      text: normalize(el.textContent)
    }));
    const reveal = (target, focus = true) => {
      if (!target || !root.contains(target)) return;
      for (let el = target; el && el !== root; el = el.parentElement) {
        if (el.tagName === 'DETAILS') el.open = true;
      }
      target.querySelectorAll('details.ca-record-details').forEach(el => { el.open = true; });
      requestAnimationFrame(() => {
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
        if (focus) {
          const focusTarget = target.matches('details') ? target.querySelector('summary') : target;
          if (!focusTarget.hasAttribute('tabindex') && focusTarget.tagName !== 'SUMMARY') focusTarget.tabIndex = -1;
          focusTarget.focus({ preventScroll: true });
        }
      });
    };
    const refresh = () => {
      const terms = normalize(input.value.trim()).split(' ').filter(Boolean);
      list.replaceChildren();
      list.hidden = terms.length === 0;
      if (!terms.length) {
        status.textContent = `${records.length} ${status.dataset.total.toLocaleLowerCase()}`;
        return;
      }
      const matches = records.filter(record => terms.every(term => record.text.includes(term)));
      status.textContent = matches.length ? `${matches.length} ${status.dataset.match}` : status.dataset.empty;
      const fragment = document.createDocumentFragment();
      matches.forEach(record => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${record.el.id}`;
        a.textContent = record.title;
        const snippet = document.createElement('span');
        const pos = record.text.indexOf(terms[0]);
        const start = Math.max(0, pos - 35);
        snippet.textContent = `${record.section} · ${start ? '…' : ''}${record.body.slice(start, start + 180)}${record.body.length > start + 180 ? '…' : ''}`;
        li.append(a, snippet);
        fragment.append(li);
      });
      list.append(fragment);
    };
    form.hidden = false;
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('reset', () => {
      input.value = '';
      refresh();
      input.focus();
    });
    input.addEventListener('input', refresh);
    root.addEventListener('click', event => {
      const a = event.target.closest('a[href^="#"]');
      if (!a) return;
      const target = document.getElementById(a.hash.slice(1));
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      history.replaceState(null, '', a.hash);
      reveal(target);
    });
    const hashReveal = () => {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      if (id) reveal(document.getElementById(id), false);
    };
    window.addEventListener('hashchange', hashReveal);
    refresh();
    hashReveal();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
